const ENPresentationGroup = {
	"Erro ao buscar grupos de apresentação": "Error on search presentation group",
	"Não foi encontrado grupos de apresentação": "No presentation groups were found",
	"Grupos de apresentação": "Presentation group",
	"Novo grupo": "New group",
	"Grupo de apresentação excluido com sucesso": "Presentation group successfully deleted",
	"Erro ao excluir grupo de apresentação": "Error on delete presentation group",
	"Grupo de apresentação adicionado com sucesso": "Presentation group successfully added",
	"Grupo de apresentação excluído com sucesso":"Presentation group successfully deleted",
	"Grupo de apresentação alterado com sucesso": "Presentation group successfully changed",
	"Indicador excluído do grupo de apresentação com sucesso": "Indicator successfully deleted from presentation group",
	"Erro ao adicionar grupo de apresentação": "Error on add presentation group",
	"Erro ao alterar grupo de apresentação": "Error on change presentation group",
	"Exclusão do grupo de apresentação": "Delete presentation group",
	"Deseja realmente excluir o grupo": "Do you relly want o delete the group",
	"Adicionar grupo de apresentação": "Add presentation group",
	"Alterar grupo de apresentação": "Change presentation group",
	"Erro ao buscar indicadores do grupo de apresentação": "Error on search presentation group indicators",
	"Erro ao atualizar ordem do grupo de apresentação": "Error on update presentation group order",
	"Selecione indicadores para inserir no grupo de apresentação": "Select indicators to insert on presentation group",
	"Indicadores selecionados que já estão no grupo não foram inseridos": "Selected indicators that already were in the group have not been added",
	"Não foi possivel inserir nenhum indicador": "It was not possible to add any indicator",
	"Erro ao inserir indicadores no grupo": "Error on add indicators on group",
	"Erro ao excluir indicador do grupo": "Error on delete indicators from group",
	"Inserir no grupo": "Insert on group",
	"Alterar grupo": "Change group",
	"Excluir grupo": "Delete group",
	"Excluir indicador": "Delete indicator"
};

export default ENPresentationGroup;
